module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-iphone4-c74969a308d8170362f507befd9a19e1.png";